import CentralMappingMappingEntrySerializer from 'lumen/serializers/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryRoomTypeSerializer extends CentralMappingMappingEntrySerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      return super.modelNameFromPayloadKey(
        'central-mapping/mapping-entry-room-type',
      );
    }

    return key;
  }
}
